import Vue from "vue";
import VueJsonp from "vue-jsonp";
Vue.use(VueJsonp);

export default class ChartService {
  /**
   * Returnerer arkivkode for NVE tidsserier basert på parameterkode.
   * @param {number} parameterCode - Kode for parameter.
   * @returns {number} - Arkivkode.
   */
  getNVETimeSeriesArchiveCode(parameterCode) {
    const HYKVALCODE = 2;
    const HYDAGCODE = 37;
    const COMPLETECODE = 29;
    let archiveCode;
    switch (parameterCode) {
      case 0: // Nedbør
        archiveCode = HYKVALCODE;
        break;
      case 17: // Lufttemperatur
        archiveCode = HYKVALCODE;
        break;
      case 1000: // Vannstand
        archiveCode = HYKVALCODE;
        break;
      case 1001: // Vannføring
        archiveCode = HYDAGCODE;
        break;
      case 1003: // Vanntemperatur
        archiveCode = HYKVALCODE;
        break;
      case 1008: // Overløp
        archiveCode = HYKVALCODE;
        break;
      case 1055: // Driftsvannføring
        archiveCode = HYKVALCODE;
        break;
      case 1057: // Forbitapping
        archiveCode = HYKVALCODE;
        break;
      case 1075: // Pumping
        archiveCode = HYKVALCODE;
        break;
      case 2000: // Grunnvannsnivå
        archiveCode = HYDAGCODE;
        break;
      case 2011: // Smeltevann og nedbør
        archiveCode = HYKVALCODE;
        break;
      case 2002: // Snødybde
        archiveCode = HYKVALCODE;
        break;
      case 2003: // Snø-vannekvivalent
        archiveCode = HYKVALCODE;
        break;
      case 1208: //
        archiveCode = HYKVALCODE;
        break;
      case 1200: //
        archiveCode = HYKVALCODE;
        break;
      default:
        archiveCode = COMPLETECODE;
    }
    return archiveCode;
  }

  /**
   * Henter døgnverdier for gitt stasjon, parameter og periode.
   * @param {string} stasjonNr - Stasjonsnummer.
   * @param {number} stasjonParameter - Parameterkode.
   * @param {string} versjon - Versjon.
   * @param {Array} timePeriod - Tidsperiode (start og slutt).
   * @param {boolean} isExternalSeries - Om serien er ekstern.
   * @returns {Promise} - Promise med grafdata.
   */
  getChartValues(
    stasjonNr,
    stasjonParameter,
    versjon,
    timePeriod,
    isExternalSeries
  ) {
    let startPeriod, endPeriod;

    if (timePeriod != null && timePeriod.length > 1) {
      startPeriod = timePeriod[0]
        .substring(1)
        .split(" ")[0]
        .split("-");
      startPeriod[1] = (startPeriod[1].length < 2 ? "0" : "") + startPeriod[1];
      startPeriod[2] = (startPeriod[2].length < 2 ? "0" : "") + startPeriod[2];

      endPeriod = timePeriod[1]
        .substring(1)
        .split(" ")[0]
        .split("-");

      endPeriod[1] = (endPeriod[1].length < 2 ? "0" : "") + endPeriod[1];
      endPeriod[2] = (endPeriod[2].length < 2 ? "0" : "") + endPeriod[2];
    } else {
      this.currentDate = new Date();
      this.beginDate = new Date();
      this.beginDate.setMonth(this.currentDate.getMonth() - 2);
      startPeriod = [
        this.beginDate.getFullYear(),
        this.beginDate.getMonth() < 9
          ? "0" + (this.beginDate.getMonth() + 1).toString()
          : (this.beginDate.getMonth() + 1).toString(),
        this.beginDate.getDate() < 10
          ? "0" + this.beginDate.getDate()
          : this.beginDate.getDate(),
      ];
      endPeriod = [
        this.currentDate.getFullYear(),
        this.currentDate.getMonth() < 9
          ? "0" + (this.currentDate.getMonth() + 1).toString()
          : (this.currentDate.getMonth() + 1).toString(),
        this.currentDate.getDate() < 10
          ? "0" + this.currentDate.getDate()
          : this.currentDate.getDate(),
      ];
    }

    if (isExternalSeries) {
      let id = stasjonNr + "." + stasjonParameter;

      let mth = "mean";

      let timeo = "";

      if (stasjonParameter === 0) {
        mth = "sum";
        timeo = ",timeo=6:0";
      } else if (stasjonParameter === 2002) {
        mth = "inst";
      }

      return Vue.jsonp(
        process.env.VUE_APP_CHARTSERVER_SERVICE_URL +
          startPeriod.join("") +
          "T0000;" +
          endPeriod.join("") +
          "T2359&lang=no&mth= " +
          mth +
          "&chd=ds=htsre,da=29,id=" +
          id +
          ",rt=1" +
          timeo +
          "&vfmt=json"
      );
    } else {
      let id = stasjonNr + "." + stasjonParameter + "." + versjon;

      let mth = "mean";

      let timeo = "";

      if (stasjonParameter === 0) {
        mth = "sum";
        timeo = ",timeo=6:0";
      } else if (stasjonParameter === 2002) {
        mth = "inst";
      }

      let archiveCode = this.getNVETimeSeriesArchiveCode(stasjonParameter);

      return Vue.jsonp(
        process.env.VUE_APP_CHARTSERVER_SERVICE_URL +
          startPeriod.join("") +
          "T0000;" +
          endPeriod.join("") +
          "T2359&lang=no&mth= " +
          mth +
          "&chd=ds=htsr,da=" +
          archiveCode +
          ",id=" +
          id +
          ",rt=1" +
          timeo +
          "&vfmt=json"
      );
    }
  }
}
